import React, { useMemo } from "react";
import DOMPurify from "dompurify";

const LegalContent = ({ html }) => {
  const sanitizedHtml = useMemo(() => {
    return DOMPurify.sanitize(html || "");
  }, [html]);

  return (
    <div
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
};

export default LegalContent;